import { defineComponent, openBlock, createElementBlock, createVNode, unref, createElementVNode, Fragment, renderList, toDisplayString, createCommentVNode } from "vue";
import { IconInformationStroke } from "@rei/cedar";
const _hoisted_1 = {
  class: "shipping-terms-modal"
};
const _hoisted_2 = {
  key: 0,
  class: "shipping-terms-modal__restrictions"
};
const _hoisted_3 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ShippingTermsModal",
  props: {
    restrictions: {
      default: null
    },
    htmlContent: {
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.restrictions ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(unref(IconInformationStroke), {
        class: "restrictions-icon"
      }), createElementVNode("ul", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.restrictions, (restriction) => {
        return openBlock(), createElementBlock("li", {
          key: restriction.message
        }, toDisplayString(restriction.message), 1);
      }), 128))])])) : createCommentVNode("", true), _ctx.htmlContent ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "shipping-terms-modal__cms-content",
        innerHTML: _ctx.htmlContent
      }, null, 8, _hoisted_3)) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ShippingTermsModal.mjs.map
